var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.reportSize),attrs:{"id":_vm.entity_id}})}
var staticRenderFns = []

export { render, staticRenderFns }